export default __webpack_public_path__ + "video-cc288b9.png";